import { Text, View } from "@react-pdf/renderer";
import styles from '../styles/styles';
import Element from "./element";

interface SpecialRequirementsProps {
  labels: {
    header: string;
    customerReq: string;
  };
  data: {
    customerReq: string | null | undefined;
  };
}

const SpecialRequirements = ({ labels, data }: SpecialRequirementsProps) => (
  <>
    <View style={styles.row}>
      <Text style={styles.subHeader}>{labels.header}</Text>
    </View>

    {data.customerReq !== undefined && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        <Element label={labels.customerReq} data={data.customerReq} />
      </View>
    </>}
  </>
);

export default SpecialRequirements;